import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

export const PDFViewer = ({ url, width }: { url: string; width?: number }) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);
  return (
    <div
      style={{
        textAlign: 'center',
      }}
    >
      <Document file={url} onLoadSuccess={(opts) => setNumPages(opts.numPages)}>
        <Page pageNumber={pageNumber} width={width} />
      </Document>
      <div>
        <Button
          onClick={() => {
            setPageNumber((prevPageNumber) => Math.max(prevPageNumber - 1, 1));
          }}
          disabled={pageNumber <= 1}
          variant="text"
        >
          <ArrowBackIcon />
        </Button>
        <p style={{ display: 'inline', margin: '0 10px', verticalAlign: 'middle' }}>
          {pageNumber} of {numPages}
        </p>
        <Button
          onClick={() => {
            setPageNumber((prevPageNumber) =>
              numPages ? Math.min(prevPageNumber + 1, numPages) : prevPageNumber + 1
            );
          }}
          disabled={numPages !== null && pageNumber >= numPages}
          variant="text"
        >
          <ArrowForwardIcon />
        </Button>
      </div>
    </div>
  );
};
